import { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    handleClose();
  };

  const menuItems = [
    { name: 'Home', id: 'home', path: '/' },
    { name: 'About', id: 'about', path: '/' },
    { name: 'Services', id: 'services', path: '/' },
    { name: 'Accounting', id: null, path: '/accounting' },
    // { name: 'Legal & Migration', id: null, path: '/legal-migration' },
    { name: 'Contact', id: 'contact', path: '/' },
  ];

  return (
    <AppBar position="sticky" elevation={0} sx={{ backgroundColor: 'background.paper' }}>
      <Toolbar>
        <Box
          component="img"
          src="/images/logo.png"
          alt="Abarcar Group Logo"
          sx={{ height: 40, mr: 2, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
        <Box sx={{ flexGrow: 1 }} />
        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="primary"
              aria-label="menu"
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {menuItems.map((item) => (
                <MenuItem
                  key={item.name}
                  onClick={() => {
                    if (item.id) {
                      scrollToSection(item.id);
                    } else {
                      navigate(item.path);
                      handleClose();
                    }
                  }}
                >
                  <Typography color="primary">{item.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </>
        ) : (
          <Box sx={{ display: 'flex', gap: 4 }}>
            {menuItems.map((item) => (
              <Typography
                key={item.name}
                variant="body1"
                color={item.name === 'Contact' ? 'secondary' : 'primary'}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'secondary.main',
                  },
                }}
                onClick={() => {
                  if (item.id) {
                    scrollToSection(item.id);
                  } else {
                    navigate(item.path);
                  }
                }}
              >
                {item.name}
              </Typography>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 